const pages = [
	{
	    path: '/index2',
	    name: 'index2',
	    meta: { breadcrumb: 'index2' },
	    component: () => import('@/views/pages/index2.vue')
	}, {
	    path: '/ah/:id',
	    name: 'ah',
	    meta: { breadcrumb: 'ah' },
	    component: () => import('@/views/pages/VideoPlayer.vue')
	}
]

export default pages